import React, {useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import Section from '../../components/Section'
import {getCookie, setCookie} from '../../utils'
import * as styles from './Feedback.module.scss'
import Thumb from './thumb.inline.svg'

const Feedback = () => {
  const [feedbackSumbitted, setFeedbackSumbitted] = useState(false)

  const submitFeedback = (feedback: 'yes' | 'no') => {
    if (getCookie('feedback-status') === null) {
      setCookie('feedback-status', 'feedback-submitted')
      window.dataLayer.push({
        event: 'gaevent',
        event_action: 'click',
        event_label: feedback,
        event_category: 'feedback',
      })
    }
    setFeedbackSumbitted(true)
  }

  return (
    <Section background="purple" className="text-center">
      <Row className="justify-content-center">
        <Col lg={8} xl={6}>
          <div className="border border-3 border-white rounded-5 p-5">
            <h2 className="fw-bold">We want to hear from you</h2>
            <p className="fs-5">
              After visiting this site, has your knowledge and understanding of
              chickenpox as a disease increased?
            </p>
            <div className={styles.thumbWrapper}>
              {feedbackSumbitted ? (
                <p className="fs-5 fw-bold">Thank you for your feedback!</p>
              ) : (
                <>
                  <Thumb
                    onClick={() => submitFeedback('yes')}
                    className={styles.thumbUp}
                  />
                  <Thumb
                    onClick={() => submitFeedback('no')}
                    className={styles.thumbDown}
                  />
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Section>
  )
}

export default Feedback
